import {
    IGeneralConsents,
    subscriptionPreferencesAT,
} from "../subscriptionPreferences/SubscriptionPreferencesModel";

export function generalConsentsReducer(
    state: IGeneralConsents = null,
    action
): IGeneralConsents {
    switch (action.type) {
        case subscriptionPreferencesAT.hasConsents:
            return action.consents;

        case subscriptionPreferencesAT.consentChange:
            return { ...state, [action.consentKey]: action.value };

        default:
            return state;
    }
}
